import ua from '@tencent/docs-user-agent';
import { IVipInfoService } from '@src/slide/application/service/vip-info-service/vip-info-service.interface';

export enum E_VIP_LEVEL {
    noVip = 1,
    normalVip = 2,
    superVip = 3,
    superVipPlus = 4,
}

export enum E_S_VIP_THEME {
    theme1= '1',
}

export default class VipInfoService implements IVipInfoService {
    public getIsVipTheme() {
        // 客户端判断ua
        if (ua.isTencentDocsApp) {
            const vipLevelFlag = navigator.userAgent.match(/VipLevel\/(\d+)/)?.[1] ?? 0;
            const vipThemeFlag = navigator.userAgent.match(/VipTheme\/(\d+)/)?.[1] ?? E_VIP_LEVEL.noVip;
            if ((Number(vipLevelFlag) === E_VIP_LEVEL.superVip
            || Number(vipLevelFlag) === E_VIP_LEVEL.superVipPlus) && !!Number(vipThemeFlag)) {
                return true;
            }
            return false;
        }

        // 非客户端判断直出
        return this.getIsSuperVip() && this.getUseSVipTheme();
    }

    public getIsSuperVip = () => {
        const vipInfo = window.VipInfo;
        return vipInfo?.vipLevel === 3 || vipInfo?.vipLevel === 4;
    };

    public getUseSVipTheme = () => {
        const { basicClientVars } = window;
        return basicClientVars?.userInfo?.settings?.vipTheme === '1';
    };
}
